export type TokenResolverFunction = (token: string | undefined) => void;

export interface AwsCurrentUserType {
  email: string;
  userId: string;
  studentId?: string;
  preferredName?: string;
}

export interface AwsAuthUtilSignInOptions {
  isRememberMe: boolean;
}

export enum UserRole {
  ADMIN = 'Admin',
  PARENT = 'Parent',
  GUARDIAN = 'Guardian',
  STUDENT = 'Student',
}
